/*
 © All right reserved to Equinom Ltd. © 2025.
*/
import ReactDOM from 'react-dom/client'
import AppRouter from 'content/App'
import { Provider } from 'react-redux'
import 'index.css'
import { store } from 'store'

import { ThemeProvider } from 'providers/ThemeProvider'
import {
  DynamicHeaderProvider,
  LoaderProvider,
  SnackbarProvider,
} from './providers'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { CssBaseline } from '@mui/material'
import { NotificationContainer } from 'react-notifications'
import { GlobalUploadReconnect } from './components'

const queryClient = new QueryClient()

const container = document.getElementById('root')
const root = ReactDOM.createRoot(container)

root.render(
  <Provider store={store}>
    <SnackbarProvider>
      <ThemeProvider>
        <CssBaseline />
        <LoaderProvider>
          <GlobalUploadReconnect />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <QueryClientProvider client={queryClient}>
              <DynamicHeaderProvider>
                <NotificationContainer />
                <AppRouter />
                <ToastContainer autoClose={false} />
              </DynamicHeaderProvider>
            </QueryClientProvider>
          </LocalizationProvider>
        </LoaderProvider>
      </ThemeProvider>
    </SnackbarProvider>
  </Provider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
